exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.reportTbl[data-v-241859e5]{width:100%;border-collapse:collapse}.reportTbl td[data-v-241859e5]{border:1px solid #ccc;padding:6px}.reportTbl tr td[data-v-241859e5]{text-align:left;line-height:15px}.txtRight[data-v-241859e5]{text-align:right!important}.reportTbl tr.txtCenter td[data-v-241859e5]{text-align:center}.reportTbl tr.tb-td td[data-v-241859e5]{font-weight:700;text-align:center;border:none}td.textCenter[data-v-241859e5]{text-align:center!important}td.textRight[data-v-241859e5]{text-align:right!important}.text-center[data-v-241859e5]{text-align:center!important}.text-bold[data-v-241859e5]{font-weight:700;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-241859e5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportGenerate/pdf/trainingInformationDetailReport.vue
// module id = 1672
// module chunks = 3